module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/2024-join-opt-online-and-mag-7bf2dea0145c03398bdaf5506eb417b7.png";